import { NgModule } from '@angular/core';
import { PreviewAnyFile } from '@ionic-native/preview-any-file/ngx';

@NgModule({
  providers: [PreviewAnyFile],
})
export class FileViewerModule {}
